// Utility functions for handling product images

// Get S3 base URL from environment variables
const S3_BASE_URL = process.env.REACT_APP_S3_BASE_URL || 'https://eldai-commands-images.s3.eu-north-1.amazonaws.com';

/**
 * Generates the S3 image URL for a product based on its reference number (code)
 * @param referenceNumber - The product code/reference number
 * @returns The full S3 URL for the product image
 */
export const getProductImageUrl = (referenceNumber: string): string => {
    if (!referenceNumber) {
        return '';
    }

    // Clean the reference number to ensure it's URL-safe
    const cleanReference = referenceNumber.trim();

    return `${S3_BASE_URL}/${cleanReference}.jpg`;
};

/**
 * Checks if a product has a valid reference number for image generation
 * @param product - The product object
 * @returns boolean indicating if an image URL can be generated
 */
export const hasProductImage = (product: { code?: string }): boolean => {
    return Boolean(product.code && product.code.trim());
};

/**
 * Generates the S3 image URL for a photo that may already include the file extension
 * @param photoUrl - The photo filename/URL (may already include .jpg)
 * @returns The full S3 URL for the product image
 */
export const getPhotoUrl = (photoUrl: string): string => {
    if (!photoUrl) {
        return '';
    }

    // Clean the photo URL
    const cleanPhotoUrl = photoUrl.trim();
    
    // If it already includes the S3 base URL, return as is
    if (cleanPhotoUrl.startsWith('http')) {
        return cleanPhotoUrl;
    }
    
    // If it already has .jpg extension, don't add another one
    if (cleanPhotoUrl.endsWith('.jpg')) {
        return `${S3_BASE_URL}/${cleanPhotoUrl}`;
    }
    
    // Otherwise, add .jpg extension
    return `${S3_BASE_URL}/${cleanPhotoUrl}.jpg`;
};
